import { cn } from '../../../lib/cn';
import { clientInitials } from '../client-format';
import { ClientDot } from './ClientDot';

/**
 * Kafelek klienta z inicjałami (Figma 05 Klienci, lista: 32 px, bg/elevated, zaokrąglenie 8) z kropką koloru
 * klienta w rogu.
 */
export function ClientTile({
  name,
  color,
  size = 32,
  className,
}: {
  name: string;
  color?: string | null;
  size?: 32 | 40;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'relative inline-flex shrink-0 items-center justify-center rounded-lg bg-elevated font-semibold text-fg-secondary select-none',
        size === 32 ? 'size-8 text-caption' : 'size-10 text-body-s',
        className,
      )}
    >
      {clientInitials(name)}
      {color && <ClientDot color={color} size={8} className="absolute -right-0.5 -bottom-0.5 ring-2 ring-canvas" />}
    </span>
  );
}
